import { hash, theme } from '@zonofi/common';

export const getBackgroundColor = (title: string) => {
  const avatarBackground = theme.avatarColors;
  const bgColor = avatarBackground[hash(title, avatarBackground.length)];
  return bgColor;
};

export const getAvatarTextColor = (title: string) => {
  const colors = theme.nameColors;
  const c = colors[hash(title, colors.length)];
  return c;
};

export const getAvatarBorderColor = (title: string) => {
  const colors = theme.borderColors;
  const borderColor = colors[hash(title, colors.length)];

  return borderColor;
};
